"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _openpgp = _interopRequireWildcard(require("openpgp"));

var Identity =
/*#__PURE__*/
function () {
  function Identity(key) {
    (0, _classCallCheck2["default"])(this, Identity);
    this._key = key;
  }

  (0, _createClass2["default"])(Identity, [{
    key: "hasId",
    value: function hasId(id) {
      return id.bytes === this._key.getKeyId().bytes;
    }
  }, {
    key: "unlock",
    value: function unlock(passphrase) {
      return this._key.decrypt(passphrase);
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(data, receivers) {
        var raw, options, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                raw = JSON.stringify(data);
                options = {
                  message: _openpgp.message.fromText(raw),
                  publicKeys: receivers.map(function (r) {
                    return r.publicKey;
                  }),
                  privateKeys: [this._key]
                };
                _context.next = 4;
                return _openpgp["default"].encrypt(options);

              case 4:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encrypt(_x, _x2) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(armored, senders) {
        var options, result, _result$signatures, signature, data, sender;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _openpgp.message.readArmored(armored);

              case 2:
                _context2.t0 = _context2.sent;
                _context2.t1 = senders.map(function (r) {
                  return r.publicKey;
                });
                _context2.t2 = [this._key];
                options = {
                  message: _context2.t0,
                  publicKeys: _context2.t1,
                  privateKeys: _context2.t2
                };
                _context2.next = 8;
                return _openpgp["default"].decrypt(options);

              case 8:
                result = _context2.sent;
                _result$signatures = (0, _slicedToArray2["default"])(result.signatures, 1), signature = _result$signatures[0];

                if (signature.valid) {
                  _context2.next = 12;
                  break;
                }

                throw new Error('Sender not known');

              case 12:
                data = JSON.parse(result.data);
                sender = senders.find(function (s) {
                  return s.hasId(signature.keyid);
                });

                if (sender) {
                  _context2.next = 16;
                  break;
                }

                throw new Error('Sender identity not found');

              case 16:
                return _context2.abrupt("return", {
                  sender: sender,
                  data: data
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function decrypt(_x3, _x4) {
        return _decrypt.apply(this, arguments);
      }

      return decrypt;
    }()
  }, {
    key: "fingerprint",
    get: function get() {
      return this._key.getFingerprint();
    }
  }, {
    key: "publicKey",
    get: function get() {
      return this._key.toPublic();
    }
  }, {
    key: "isPrivate",
    get: function get() {
      return this._key.isPrivate();
    }
  }, {
    key: "isUnlocked",
    get: function get() {
      var result = this._key.isDecrypted();

      return result === null ? true : result;
    }
  }], [{
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(_ref) {
        var name, email, passphrase, options, key, privkey;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                name = _ref.name, email = _ref.email, passphrase = _ref.passphrase;
                options = {
                  userIds: [{
                    name: name,
                    email: email
                  }],
                  passphrase: passphrase,
                  curve: 'ed25519'
                };
                _context3.next = 4;
                return _openpgp["default"].generateKey(options);

              case 4:
                key = _context3.sent;
                privkey = key.privateKeyArmored;
                return _context3.abrupt("return", privkey);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function create(_x5) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "open",
    value: function () {
      var _open = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(armored, passphrase) {
        var _ref2, keys, _keys, key, identity;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _openpgp.key.readArmored(armored);

              case 2:
                _ref2 = _context4.sent;
                keys = _ref2.keys;
                _keys = (0, _slicedToArray2["default"])(keys, 1), key = _keys[0];
                identity = new Identity(key);

                if (!passphrase) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 9;
                return identity.unlock(passphrase);

              case 9:
                return _context4.abrupt("return", identity);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function open(_x6, _x7) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }]);
  return Identity;
}();

var _default = Identity;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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